import { render } from "./Button.vue?vue&type=template&id=bed5c2fc"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "@/assets/css/tailwind.css?vue&type=style&index=0&lang=css"
import "@/assets/css/_fontface.css?vue&type=style&index=1&lang=css"
import "@/assets/css/_variables.css?vue&type=style&index=2&lang=css"
import "@/assets/css/_global.css?vue&type=style&index=3&lang=css"
import "@/assets/css/_animations.css?vue&type=style&index=4&lang=css"
import "@/assets/css/main.css?vue&type=style&index=5&lang=css"

import exportComponent from "/home/ubuntu/jenkins/workspace/suiteweb-web-components_gamma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__